import React, {useState} from 'react';
import styled from "styled-components";
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";
import PageTitle from "../../components/PageTitle";
import {getQueryValue} from "../../domain/queryHandler";
import {useLocation} from "react-router-dom";
import InventoryAlertsMain from "../../components/alerts/inventoryManagementAlerts/InventoryAlertsMain";
import ALERT_MAP from "../../maps/alertMap";
import LowInventory from "../../components/alerts/inventoryManagementAlerts/LowInventory";
import ReloadShelves from "../../components/alerts/inventoryManagementAlerts/ReloadShelves";
import useZibi from "../../zibi/UseZibi";
import {api} from "../../maps/data";
import ZeroLine from "../../components/alerts/inventoryManagementAlerts/ZeroLine";
import PlanogramNotValid from "../../components/alerts/inventoryManagementAlerts/PlanogramNotValid";
import PlanogramNotConfigured from "../../components/alerts/inventoryManagementAlerts/PlanogramNotConfigured";

const WrapperStyled = styled.div`

`;


const ImAlertsPage = () => {
    const location = useLocation();
    const type = getQueryValue(location, 'type');
    const eventId = getQueryValue(location, 'eventId');

    const [placements, s_placements] = useState({});

    const [fields, set_fields] = useZibi('fields');
    const [sensors, set_sensors] = useZibi('sensors');
    const [productsById, set_productsById] = useZibi('productsById');

    const getSensors = async (dataToParse, shouldGetPlacements) => {
        const sensorIds = new Set();
        const sensorIdsPlacements = new Set();
        dataToParse.forEach(item => {
            if (item?.data?.sensorId) {
                sensorIdsPlacements.add(item.data.sensorId);
                if (!sensors[item.data.sensorId]) {
                    sensorIds.add(item.data.sensorId);
                }
            }
        });

        if (sensorIds?.size) {
            api({
                type: "getSensors",
                data: {
                    ids: Array.from(sensorIds)
                }
            }).then(data => {
                const temp = {};
                data.forEach(dd => {
                    temp[dd._id] = dd;
                });
                set_sensors(temp);
            }).catch(e => {
                console.error(e);
            });
        }

        if (sensorIdsPlacements.size && shouldGetPlacements) {
            getPlacements(Array.from(sensorIdsPlacements));
        }
    };
    const getFields = async (dataToParse) => {
        const fieldIds = new Set();
        dataToParse.forEach(item => {
            if (item?.data?.fieldId) {
                if (!fields[item.data.fieldId]) {
                    fieldIds.add(item.data.fieldId);
                }
            }
        });

        if (fieldIds?.size) {
            api({
                type: "getFieldsLean",
                data: {
                    ids: Array.from(fieldIds)
                }
            }).then(data => {
                const temp = {};
                data.forEach(dd => {
                    temp[dd._id] = dd;
                });
                set_fields(temp);
            }).catch(e => {
                console.error(e);
            });
        }
    };
    const getPlacements = async (ids) => {
        api({
            type: "getPlacements",
            data: {
                sensorIds: ids
            }
        }).then(data => {
            const temp = {};
            data.forEach(dd => {
                if (!temp[dd.sensorId]) {
                    temp[dd.sensorId] = [];
                }
                temp[dd.sensorId].push(dd);
            });
            s_placements(temp);
        }).catch(e => {
            console.error(e);
        });
    };

    const getProducts = async (ids) => {
        api({
            type: 'getProducts', data: {productIds : ids, ignoreCategory: true, page: 0}
        }).then(({products}) => {
            const temp = {};
            for (let i = 0; i < products.length; i++) {
                const product = products[i];
                temp[product._id] = product;
            }
            set_productsById({...productsById, ...temp});
        });
    }

    return (
        <div style={{height: '100%', padding: 20, overflow: 'auto'}}>
            <PageTitle>
                <div style={{position: 'relative'}}>
                    <Icn>priorityHighIcon</Icn> <Tx>menu.alert</Tx>
                </div>
            </PageTitle>
            <WrapperStyled>
                {type && (
                    <div>
                        {type === ALERT_MAP.eventTypesList.PLANOGRAM_NOT_VALID && (
                            <PlanogramNotValid
                                getFields={getFields}
                                getSensors={getSensors}
                                placements={placements}
                                eventId={eventId}
                            />
                        )}
                        {type === ALERT_MAP.eventTypesList.ZERO_LINE && (
                            <ZeroLine
                                getFields={getFields}
                                getSensors={getSensors}
                                placements={placements}
                                eventId={eventId}
                            />
                        )}
                        {type === ALERT_MAP.eventTypesList.RELOAD_SHELF && (
                            <ReloadShelves
                                getFields={getFields}
                                getSensors={getSensors}
                                placements={placements}
                                eventId={eventId}
                            />
                        )}
                        {type === ALERT_MAP.eventTypesList.PLANOGRAM_NOT_CONFIGURED && (
                            <PlanogramNotConfigured
                                getFields={getFields}
                                getSensors={getSensors}
                                placements={placements}
                                eventId={eventId}
                            />
                        )}
                        {type === ALERT_MAP.eventTypesList.LOW_INVENTORY && (
                            <LowInventory
                                getProducts={getProducts}
                                eventId={eventId}
                            />
                        )}
                    </div>
                )}
                {!type && (
                    <InventoryAlertsMain/>
                )}
            </WrapperStyled>
        </div>
    );
};

export default ImAlertsPage;